import { render } from "./MActionIcon.vue?vue&type=template&id=86943c24&scoped=true"
import script from "./MActionIcon.vue?vue&type=script&lang=js"
export * from "./MActionIcon.vue?vue&type=script&lang=js"

import "./MActionIcon.vue?vue&type=style&index=0&id=86943c24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86943c24"]])

export default __exports__